// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/img//show.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/img/hide.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-outline-primary{
	color:#32879c ;
	border-color:#32879c;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#32879c;
	color:#fff;
}
.hand_geture:hover{
    color: blue;
}
.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}


.mainDiv__{
	margin-top:80px;
}

.widget{
	/* background: #FFFFFF; */
    /* box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11); */
    /* border-color: blue !important; */
}
.widgetIcon img{
	width:60px;height:60px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.titlebd_drive {
    font-size: 1.2em;
    /* color: #000; */
    color: rgb(98, 89, 89) !important;
    font-weight: 500;
    margin-bottom: 0px;
	/* text-align:center; */
    /* margin-bottom: 0; */
    /* padding-bottom: 0; */
    
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
    min-height: 200px;
}
.tablebox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
    /* min-height: 250px; */
    min-height: 295px;
}
	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}
	
/* PageTwo */
.bt-graph {
    border-right: solid 1px #b5b5b5;
}





/* media queries start here */
@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}
@media (max-width: 768px){
    .popover,.dropdown-menu {
    top: 20% !important;
    
}
}

/* @media screen and (max-width: 800px) {
    .mainDiv{
        margin-top: 130px;
    }
    } */

    /* @media only screen and  (max-width: 1069px) {
        .mainDiv__{
            margin-top: 170px;
        }
        } */


        @media only screen and  (max-width: 380px) {
            .mainDiv{
                margin-top: 170px;
            }
            }
        

        @media only screen and  (max-width: 768px) {
            .mainDiv__{
                margin-top: 130px;
            }
            }

            @media only screen and  (max-width: 380px) {
                .mainDiv__{
                    margin-top: 170px;
                }
                }
            

            @media only screen and  (max-width: 450px) {
                .widgetIcon_{
                    /* height: 50px;
                    width: 30px; */
                }
                }


/* @media only screen and  (max-width: 1053px) {
.mainDiv{
	margin-top: 170px;
}
} */

@media only screen and  (max-width: 768px) {
    .mainDiv{
        margin-top: 130px;
    }
    }
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}

.select_col_title {
	background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;
  }
  .react-datepicker__input-container input[type="text"] {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
  }
  .top-filter {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
}
.css-1r4vtzz {
    border-radius: 3px !important;
    font-size: 14px !important;
    color: #353535 !important;
    padding: 5px 5px !important;
    text-indent: 10px !important;
}
.css-1r4vtzz {
    width: 100% !important;
}
.submit_btn {
    color: #fff !important;
    width: 100%;
    margin-top: 23%;
    background: #32879c;
    border: #32879c;
}



.reset_btn {
    color: #fff !important;
    width: 100%;
    margin-top: 23%;
    background: #7b7878;
    border: silver;
}

@media screen and (max-width: 768px) {
    .submit_btn{
        margin-top: 2%;
    }
   
    .reset_btn{
        margin-top: 2%;
    }
    }
    .tablecontainer {
        height: 202px;
        overflow-y: scroll;
        width: 99.5%;
    }
    .btn-infotable {
        color: black;
        background-color: #fff;
        border-color: #32879c;
        
    }
    .hand_geture {
        cursor: pointer !important;
    }

    .filters-showhide {
        width: 100%;
        margin: 0 15px;
    }
    
    
    
    .filter-form {
        display: block;
        width: 100%;
        margin-top: -11px;
        background: #454545;
        position: relative;
        min-height: 20px;
        color: #000;
        height: 1px;
        position: relative;
    }
    .show-hide-button[aria-expanded="false"] {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top #32879c;
        width: 50px !important;
        height: 25px !important;
        border-radius: 0px;
        border: none;
        margin-top: 2px;
       
       
    }
    
    .show-hide-button[aria-expanded="true"] {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center top #32879c;
        width: 50px !important;
        height: 25px !important;
        border-radius: 0px;
        border: none;
        margin-top: 2px;
        
    }
    .FilterDiv {
        background: #e7e7e7;
        /* padding-top: 25px; */
        padding-bottom: 10px;
        margin-right: -5px;
        margin-left: -1px;
        margin-top: 2px;
        position: relative;
        /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */
    }
    .show-hide-button {
        font-size: 12px;
        color: #fff;
        border: none;
        outline: none;
        box-shadow: none !important;
        background: #245571;
        text-indent: 19px;
        width: 50px;
        height: 25px;
        z-index: 2;
       position: absolute;
       top: -1px;
       right: 19px;
    }

    /***************************/
    .chartHGT strong {
        position: absolute;
        top: 5px;
        right: 25px;
        /* border-radius: 6px; */
    }

    /* .chartHGT{
        border-radius: 6px;
    } */
    strong.align-top-chn{
        top: 35px;
    }
    /* .fixed-top {
        position: relative !important;
    } */
    strong#oldpz {
        top: 28px;
        right: 4px;
        z-index: 1;
    }


    .row.equal-cols {
        display: flex;
        flex-wrap: wrap;
    }

    .row.equal-cols:before,
    .row.equal-cols:after {
        display: block;
    }

    .row.equal-cols>[class*='col-'] {
        display: flex;
        flex-direction: column;
    }

    .row.equal-cols>[class*='col-']>* {
        flex: 1 1 auto;
    }

.new_drive_dashboard{
    background-color: #ecf1f4;
}

.drivediv{
    /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */
    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;
}

.widgetstyle{
    border: 1.5px solid #32879c;
    border-radius: 10px;
}

.drive_selection_box{
    border: 1px solid #e9eef4;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;
}

.drive_table_div{
    height: 40px;
    width: 100%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 4px;
    position: relative;
    border-radius: 6px;
    /* border: 1px solid #dcdbdb; */
}

.drive_span{
    font-weight: 600;
}

.dropdown_img{
    height: 28px;
    width: 47px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.dropdown_div{
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 4px 4px;
    padding: 10px;
    background-color: #e7e7e7;
    border: 1px solid #dcdbdb;
}

.drive_graph{
    border-radius: 6px;
}

.kpi_value{
    font-weight: 600;
    /* font-size: 1rem !important; */
}

.box_title{
    /* background-color: #cdcfce; */
    background-color: #E0E0E0;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    color: #32879c !important;
    font-size: 1.1em !important;
    font-weight: 600 !important;
}

.kpi_text{
    font-size: 13px;
}

.raphael-group-GUjlfOCU{
    display: none !important;
}


.dropdownSelect {
    width: auto !important;
    height: 30px;
    font-size: 12px !important;
}

/* .form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
    width: 30px;
} */


.table-container {
    height: 257px; /* Set the height of the table container */
    overflow-y: scroll; /* Add vertical scroll when content overflows */
    margin-bottom: 0;
    scrollbar-width: thin; 
  }
  
  .table {
    width: 100%; /* Ensure the table takes up the full width */
  }

.graph_two{
    min-height: 295px;
}

  
  
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Driveanalysis/Driveanalysis.css"],"names":[],"mappings":";AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;AACA;IACI,WAAW;AACf;AACA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;;AAGA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;IACtB,kDAAkD;IAClD,mCAAmC;AACvC;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;CACrB,uBAAuB;IACpB,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;AACrB;CACC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA,YAAY;AACZ;IACI,+BAA+B;AACnC;;;;;;AAMA,6BAA6B;AAC7B;AACA;CACC,gBAAgB;AACjB;AACA;AACA;IACI;IACA,mBAAmB;;AAEvB;AACA;;AAEA;;;;OAIO;;IAEH;;;;WAIO;;;QAGH;YACI;gBACI,iBAAiB;YACrB;YACA;;;QAGJ;YACI;gBACI,iBAAiB;YACrB;YACA;;YAEA;gBACI;oBACI,iBAAiB;gBACrB;gBACA;;;YAGJ;gBACI;oBACI;kCACc;gBAClB;gBACA;;;AAGhB;;;;GAIG;;AAEH;IACI;QACI,iBAAiB;IACrB;IACA;;AAEJ;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;;AAEA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;;;AAIA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;IACA;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,sBAAsB;QACtB,qBAAqB;;IAEzB;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;;;IAIA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,gFAA0E;QAC1E,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,eAAe;;;IAGnB;;IAEA;QACI,gFAAyE;QACzE,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,eAAe;;IAEnB;IACA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;QACpB,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,iDAAiD;IACrD;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,UAAU;OACX,kBAAkB;OAClB,SAAS;OACT,WAAW;IACd;;IAEA,4BAA4B;IAC5B;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,wBAAwB;IAC5B;;IAEA;;OAEG;IACH;QACI,SAAS;IACb;IACA;;OAEG;IACH;QACI,SAAS;QACT,UAAU;QACV,UAAU;IACd;;;IAGA;QAGI,aAAa;QAGb,eAAe;IACnB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QAGI,aAAa;QAGb,sBAAsB;IAC1B;;IAEA;QAGI,cAAc;IAClB;;AAEJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,iEAAiE;IACjE,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;;;GAKG;;;AAGH;IACI,aAAa,EAAE,0CAA0C;IACzD,kBAAkB,EAAE,+CAA+C;IACnE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW,EAAE,6CAA6C;EAC5D;;AAEF;IACI,iBAAiB;AACrB","sourcesContent":["\r\n.btn-outline-primary{\r\n\tcolor:#32879c ;\r\n\tborder-color:#32879c;\r\n}\r\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\r\n\tbackground-color:#32879c;\r\n\tcolor:#fff;\r\n}\r\n.hand_geture:hover{\r\n    color: blue;\r\n}\r\n.bg-white{\r\n\tbackground-color:#fff;\r\n}\r\n.headBG {\r\nbox-sizing: border-box;\r\nbackground: #FFFFFF;\r\nborder: 1px solid #358696;\r\n}\r\n\r\n.mainDiv{\r\n\tmargin-top:80px;\r\n}\r\n\r\n\r\n.mainDiv__{\r\n\tmargin-top:80px;\r\n}\r\n\r\n.widget{\r\n\t/* background: #FFFFFF; */\r\n    /* box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11); */\r\n    /* border-color: blue !important; */\r\n}\r\n.widgetIcon img{\r\n\twidth:60px;height:60px;\r\n}\r\n.widgetIcon-32 img{\r\n\twidth:32px;height:32px;\r\n}\r\n.titlebd_drive {\r\n    font-size: 1.2em;\r\n    /* color: #000; */\r\n    color: rgb(98, 89, 89) !important;\r\n    font-weight: 500;\r\n    margin-bottom: 0px;\r\n\t/* text-align:center; */\r\n    /* margin-bottom: 0; */\r\n    /* padding-bottom: 0; */\r\n    \r\n}\r\n.chartbox{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* font-size: 14px; */\r\n    min-height: 200px;\r\n}\r\n.tablebox{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* font-size: 14px; */\r\n    /* min-height: 250px; */\r\n    min-height: 295px;\r\n}\r\n\th5, .h5 {\r\n    font-size: 1.1rem !important;\r\n}\r\np {\r\n    line-height: 1rem !important;\r\n}\r\nsmall, .small {\r\n    font-size: 80% !important;\r\n}\r\n\t\r\ntable tr td {\r\n\tfont-size:0.8em;\r\n}\r\n.accordion-button{\r\n\tfont-size:0.5em;\r\n}\r\n.accordion-button:not(.collapsed){\r\n\tbackground-color:#e0e0e0;\r\n\tcolor:#222;\r\n}\r\n\t\r\n/* PageTwo */\r\n.bt-graph {\r\n    border-right: solid 1px #b5b5b5;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* media queries start here */\r\n@media screen and (max-width: 740px) {\r\n.titlebg {\r\n\tfont-size: 0.9em;\r\n}\r\n}\r\n@media (max-width: 768px){\r\n    .popover,.dropdown-menu {\r\n    top: 20% !important;\r\n    \r\n}\r\n}\r\n\r\n/* @media screen and (max-width: 800px) {\r\n    .mainDiv{\r\n        margin-top: 130px;\r\n    }\r\n    } */\r\n\r\n    /* @media only screen and  (max-width: 1069px) {\r\n        .mainDiv__{\r\n            margin-top: 170px;\r\n        }\r\n        } */\r\n\r\n\r\n        @media only screen and  (max-width: 380px) {\r\n            .mainDiv{\r\n                margin-top: 170px;\r\n            }\r\n            }\r\n        \r\n\r\n        @media only screen and  (max-width: 768px) {\r\n            .mainDiv__{\r\n                margin-top: 130px;\r\n            }\r\n            }\r\n\r\n            @media only screen and  (max-width: 380px) {\r\n                .mainDiv__{\r\n                    margin-top: 170px;\r\n                }\r\n                }\r\n            \r\n\r\n            @media only screen and  (max-width: 450px) {\r\n                .widgetIcon_{\r\n                    /* height: 50px;\r\n                    width: 30px; */\r\n                }\r\n                }\r\n\r\n\r\n/* @media only screen and  (max-width: 1053px) {\r\n.mainDiv{\r\n\tmargin-top: 170px;\r\n}\r\n} */\r\n\r\n@media only screen and  (max-width: 768px) {\r\n    .mainDiv{\r\n        margin-top: 130px;\r\n    }\r\n    }\r\n\t\r\n@media screen and (max-width: 480px) {\r\n.topHeader h2{\r\n\tfont-size: 22px;\r\n    padding-right: 3rem;\r\n}\r\n\t.titlebg {\r\n\t\tfont-size: 0.9em;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n\t.topHeader h2{\r\n\tfont-size: 16px;\r\n\t\tpadding-right: 0rem;\r\n\t}\r\n}\r\n\r\n.select_col_title {\r\n\tbackground: transparent; \r\n\tpadding: 0px !important;\r\n\ttext-align: left;\r\n\t margin-bottom:0px !important;\r\n\tcolor: #358696 !important;\r\n\tfont-weight: 600;\r\n\tdisplay: block;\r\n  }\r\n  .react-datepicker__input-container input[type=\"text\"] {\r\n    width: 100%;\r\n    background: #fff;\r\n    height: 35px;\r\n    border: solid 1px #a5a5a5;\r\n    border-radius: 3px;\r\n    font-size: 14px;\r\n    color: #353535;\r\n    text-indent: 10px;\r\n    margin-bottom: 12px;\r\n  }\r\n  .top-filter {\r\n    width: 100%;\r\n    background: #fff;\r\n    height: 35px;\r\n    border: solid 1px #a5a5a5;\r\n    border-radius: 3px;\r\n    font-size: 14px;\r\n    color: #353535;\r\n    text-indent: 10px;\r\n    margin-bottom: 12px;\r\n}\r\n.css-1r4vtzz {\r\n    border-radius: 3px !important;\r\n    font-size: 14px !important;\r\n    color: #353535 !important;\r\n    padding: 5px 5px !important;\r\n    text-indent: 10px !important;\r\n}\r\n.css-1r4vtzz {\r\n    width: 100% !important;\r\n}\r\n.submit_btn {\r\n    color: #fff !important;\r\n    width: 100%;\r\n    margin-top: 23%;\r\n    background: #32879c;\r\n    border: #32879c;\r\n}\r\n\r\n\r\n\r\n.reset_btn {\r\n    color: #fff !important;\r\n    width: 100%;\r\n    margin-top: 23%;\r\n    background: #7b7878;\r\n    border: silver;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .submit_btn{\r\n        margin-top: 2%;\r\n    }\r\n   \r\n    .reset_btn{\r\n        margin-top: 2%;\r\n    }\r\n    }\r\n    .tablecontainer {\r\n        height: 202px;\r\n        overflow-y: scroll;\r\n        width: 99.5%;\r\n    }\r\n    .btn-infotable {\r\n        color: black;\r\n        background-color: #fff;\r\n        border-color: #32879c;\r\n        \r\n    }\r\n    .hand_geture {\r\n        cursor: pointer !important;\r\n    }\r\n\r\n    .filters-showhide {\r\n        width: 100%;\r\n        margin: 0 15px;\r\n    }\r\n    \r\n    \r\n    \r\n    .filter-form {\r\n        display: block;\r\n        width: 100%;\r\n        margin-top: -11px;\r\n        background: #454545;\r\n        position: relative;\r\n        min-height: 20px;\r\n        color: #000;\r\n        height: 1px;\r\n        position: relative;\r\n    }\r\n    .show-hide-button[aria-expanded=\"false\"] {\r\n        background: url(/public/assets/img//show.png) no-repeat center top #32879c;\r\n        width: 50px !important;\r\n        height: 25px !important;\r\n        border-radius: 0px;\r\n        border: none;\r\n        margin-top: 2px;\r\n       \r\n       \r\n    }\r\n    \r\n    .show-hide-button[aria-expanded=\"true\"] {\r\n        background: url(/public/assets/img/hide.png) no-repeat center top #32879c;\r\n        width: 50px !important;\r\n        height: 25px !important;\r\n        border-radius: 0px;\r\n        border: none;\r\n        margin-top: 2px;\r\n        \r\n    }\r\n    .FilterDiv {\r\n        background: #e7e7e7;\r\n        /* padding-top: 25px; */\r\n        padding-bottom: 10px;\r\n        margin-right: -5px;\r\n        margin-left: -1px;\r\n        margin-top: 2px;\r\n        position: relative;\r\n        /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */\r\n    }\r\n    .show-hide-button {\r\n        font-size: 12px;\r\n        color: #fff;\r\n        border: none;\r\n        outline: none;\r\n        box-shadow: none !important;\r\n        background: #245571;\r\n        text-indent: 19px;\r\n        width: 50px;\r\n        height: 25px;\r\n        z-index: 2;\r\n       position: absolute;\r\n       top: -1px;\r\n       right: 19px;\r\n    }\r\n\r\n    /***************************/\r\n    .chartHGT strong {\r\n        position: absolute;\r\n        top: 5px;\r\n        right: 25px;\r\n        /* border-radius: 6px; */\r\n    }\r\n\r\n    /* .chartHGT{\r\n        border-radius: 6px;\r\n    } */\r\n    strong.align-top-chn{\r\n        top: 35px;\r\n    }\r\n    /* .fixed-top {\r\n        position: relative !important;\r\n    } */\r\n    strong#oldpz {\r\n        top: 28px;\r\n        right: 4px;\r\n        z-index: 1;\r\n    }\r\n\r\n\r\n    .row.equal-cols {\r\n        display: -webkit-flex;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-flex-wrap: wrap;\r\n        -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .row.equal-cols:before,\r\n    .row.equal-cols:after {\r\n        display: block;\r\n    }\r\n\r\n    .row.equal-cols>[class*='col-'] {\r\n        display: -webkit-flex;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-flex-direction: column;\r\n        -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .row.equal-cols>[class*='col-']>* {\r\n        -webkit-flex: 1 1 auto;\r\n        -ms-flex: 1 1 auto;\r\n        flex: 1 1 auto;\r\n    }\r\n\r\n.new_drive_dashboard{\r\n    background-color: #ecf1f4;\r\n}\r\n\r\n.drivediv{\r\n    /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */\r\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;\r\n}\r\n\r\n.widgetstyle{\r\n    border: 1.5px solid #32879c;\r\n    border-radius: 10px;\r\n}\r\n\r\n.drive_selection_box{\r\n    border: 1px solid #e9eef4;\r\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;\r\n}\r\n\r\n.drive_table_div{\r\n    height: 40px;\r\n    width: 100%;\r\n    background-color: #fff;\r\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 4px;\r\n    position: relative;\r\n    border-radius: 6px;\r\n    /* border: 1px solid #dcdbdb; */\r\n}\r\n\r\n.drive_span{\r\n    font-weight: 600;\r\n}\r\n\r\n.dropdown_img{\r\n    height: 28px;\r\n    width: 47px;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.dropdown_div{\r\n    width: 100%;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    border-radius: 0 0 4px 4px;\r\n    padding: 10px;\r\n    background-color: #e7e7e7;\r\n    border: 1px solid #dcdbdb;\r\n}\r\n\r\n.drive_graph{\r\n    border-radius: 6px;\r\n}\r\n\r\n.kpi_value{\r\n    font-weight: 600;\r\n    /* font-size: 1rem !important; */\r\n}\r\n\r\n.box_title{\r\n    /* background-color: #cdcfce; */\r\n    background-color: #E0E0E0;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n    color: #32879c !important;\r\n    font-size: 1.1em !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.kpi_text{\r\n    font-size: 13px;\r\n}\r\n\r\n.raphael-group-GUjlfOCU{\r\n    display: none !important;\r\n}\r\n\r\n\r\n.dropdownSelect {\r\n    width: auto !important;\r\n    height: 30px;\r\n    font-size: 12px !important;\r\n}\r\n\r\n/* .form-select:focus {\r\n    border-color: #358696;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\r\n    width: 30px;\r\n} */\r\n\r\n\r\n.table-container {\r\n    height: 257px; /* Set the height of the table container */\r\n    overflow-y: scroll; /* Add vertical scroll when content overflows */\r\n    margin-bottom: 0;\r\n    scrollbar-width: thin; \r\n  }\r\n  \r\n  .table {\r\n    width: 100%; /* Ensure the table takes up the full width */\r\n  }\r\n\r\n.graph_two{\r\n    min-height: 295px;\r\n}\r\n\r\n  \r\n  \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
